// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { TabProps } from "@insite/mobius/Tab";
import get from "@insite/mobius/utilities/get";
import getColor from "@insite/mobius/utilities/getColor";
import Color from "color";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            outline: none;
            flex: 1 1 auto;
            text-align: center;
            height: 30px;
            min-width: auto;
            ovewrflow-y: hidden;
            white-space: nowrap;
            position: relative;
            font-size: 22px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 22px;
            padding: 4px 4px;
            transition: color 0.2s;
            cursor: pointer;
            width: auto;
            flex: unset;
            border-bottom-width: ${({ selected, theme }: TabProps) => (selected ? "2px" : 0)};
            border-bottom-color: ${getColor("primary")};
            background: ${getColor("transparent")};
            color: ${({ selected, theme }: TabProps) => (selected ? getColor("text.main") : getColor("secondary"))};

            &:first-child {
                text-align: start;
                padding-left: 0;
            }

            &:hover {
                color: ${getColor("text.main")};
                border-bottom-width: 0;
                &:after {
                    content: none;
                }
            }

            &:focus,
            &:active {
                outline: none !important;
                color: ${getColor("text.main")};

                &:after {
                    content: "";
                    position: absolute;
                    bottom: -5px;
                    left: 0;
                    height: 2px;
                    width: 100%;
                    background-color: ${getColor("secondary")};
                }
            }
        `,
    },
    groupDefaultProps: {
        cssOverrides: {
            wrapper: css`
                padding: 0;
                display: block;
            `,
            tabGroup: css`
                overflow-y: auto;
                position: relative;
                padding-bottom: 0;
                padding: 0;
                z-index: 0;
                min-height: 35px;
                &::after {
                    background-color: ${getColor("common.ui3")};
                    content: "";
                    content: "*";
                    height: 2px;
                    position: absolute;
                    bottom: 5px;
                    z-index: -1;
                    overflow: hidden;
                    width: 100%;
                }
            `,
            tabContent: css`
                border: none;
                margin: 25px 0;
            `,
        },
    },
} as xBaseTheme["tab"];
